import React, { useState } from 'react'
import { postMaterialsGroups } from '@auteco/services/snopServices'
import { Button, Dialog, DialogContent, DialogTitle, TextField } from '@material-ui/core'
import useStyles from './styles'

const initialInfo = {
    name: '',
    description: ''
}
const DialogCreateGroup = ({ open, onClose, getGroups }) => {
    const [info, setInfo] = useState(initialInfo)

    const classes = useStyles()

    const onUpdateInfo = ({ type, value }) => {
        setInfo(prevInfo => ({ ...prevInfo, [type]: value }))
    }
    const onCreateGroups = async () => {
        const body = {
            nombre: info.name,
            descripcion: info.description
        }
        const { id } = await postMaterialsGroups({ params: body })
        if (id) {
            setInfo(initialInfo)
            getGroups()
            onClose()
        }
    }
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Crear grupo</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <TextField
                    label='Nombre'
                    variant='outlined'
                    fullWidth
                    onChange={(e) => onUpdateInfo({ type: 'name', value: e.target.value })}
                />
                <TextField
                    label='Descripción'
                    variant='outlined'
                    fullWidth
                    className={classes.textField}
                    onChange={(e) => onUpdateInfo({ type: 'description', value: e.target.value })}
                />
            </DialogContent>
            <Button disabled={info.name === '' || info.description === ''} variant='contained' color='primary' className={classes.createBtn} onClick={onCreateGroups}>Crear</Button>
        </Dialog>
    )
}

export { DialogCreateGroup }